<template>
  <!-- the visible «واتساب ميتا» send button, next to the page's SMS / إشعار الجوال / «واتساب» buttons.
       Ready: the normal style with a check-badge icon → emits `send` (the page calls its own send('meta')).
       Not ready (or unknown / an old server): muted with a lock → the «واتساب ميتا غير مفعّل» dialog. -->
  <button
    type="button"
    :class="['btn mc-btn', block ? 'btn-block' : '', size ? 'btn-' + size : '', locked ? 'mc-btn-locked' : 'mc-btn-ready']"
    :aria-label="label + (locked ? ' — غير مفعّل' : '')"
    @click="click"
  >
    <feather-icon :icon="locked ? 'LockIcon' : 'CheckCircleIcon'" :size="size == 'lg' ? '18' : '16'" class="mc-btn-ico" />
    <span>{{ label }}</span>
  </button>
</template>

<script>
import { META_BUTTON, metaState, metaStateNow, metaPick } from '@/libs/meta-channel'

export default {
  name: 'MetaSendButton',
  props: {
    label: { type: String, default: META_BUTTON },
    block: { type: Boolean, default: true },
    // the neighbours' size: 'lg' | 'sm' | ''
    size: { type: String, default: '' },
  },
  data() {
    return { s: metaStateNow() }
  },
  computed: {
    locked() {
      return !this.s.ready
    },
  },
  created() {
    metaState()
  },
  methods: {
    click() {
      var g = this
      metaPick(g).then(function (ok) {
        if (ok) g.$emit('send')
      })
    },
  },
}
</script>
